/**
 * 浏览器端文件下载工具
 */

export class ContentDispositionUtils {
  /**
   * 从 Content-Disposition 响应头解析 filename
   * @param {string | null} header
   * @param {string} [fallback]
   */
  static parseFilename(header, fallback = 'download') {
    if (!header) return fallback
    const star = header.match(/filename\*=UTF-8''([^;\s]+)/i)
    if (star?.[1]) {
      try {
        return decodeURIComponent(star[1].trim())
      } catch {
        return star[1].trim()
      }
    }
    const plainStar = header.match(/filename\*?=(?:UTF-8'')?["']?([^"';]+)["']?/i)
    if (plainStar?.[1]) return plainStar[1].trim().replace(/^["']|["']$/g, '')
    const quoted = header.match(/filename="([^"]+)"/i)
    if (quoted?.[1]) return quoted[1]
    const plain = header.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)
    if (plain?.[1]) return plain[1].replace(/['"]/g, '').trim()
    return fallback
  }
}

export class DownloadUtils {
  /** 触发浏览器保存 Blob 为本地文件 */
  static saveAs(blob, filename) {
    const a = document.createElement('a')
    a.href = URL.createObjectURL(blob)
    a.download = filename
    document.body.appendChild(a)
    a.click()
    a.remove()
    URL.revokeObjectURL(a.href)
  }
}
